<template>
     <v-dialog v-model="dialog_guest" :retain-focus="false" width="500">
        <template v-slot:activator="{on, attrs}">
            <v-btn test-tag="tag-48" :icon="icon" :text="text" :color="color" :small="icon" v-bind="attrs" v-on="on">
                <v-icon>{{ btn_icon }}</v-icon>
                {{ btn_text }}
            </v-btn>
        </template>
        <v-card>
            <v-card-title test-tag="tag-51">{{ title }}</v-card-title>
            <v-card-text>
                <slot name="body">
                </slot>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn test-tag="tag-49" text @click="dialog_guest = false"><T>Отмена</T></v-btn>
                <v-btn test-tag="tag-50" text @click.stop="onSubmit"><v-icon>{{ btn_icon }}</v-icon>{{ btn_text }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default{
    props:{
        title: String,
        btn_icon:{
            type: String,
            default: 'mdi-trash-can-outline'
        },
        btn_text: {
            type: String, 
            default: ''
        },
        icon: {
            type: Boolean,
            default: false,
        },
        text: {
            type: Boolean,
            default: false 
        },
        color: String
    },
    data: ()=>({
        dialog_guest: false
    }),
    methods:{
        onSubmit(){
            this.$emit('onSubmit')
            this.dialog_guest = false
        }
    }
}
</script>